import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  AccordionDetails,
  AccordionSummary,
  Alert,
  Button,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { FC, useEffect, useState } from "react";
import { Accordion } from "../../../../components/Accordion";
import { ApiError } from "../../../../network/mainClient/apiError";
import { TUserInfo } from "../../../verificationRequest/models";

export const UserPersonalInfoBlock: FC<{
  userInfo: TUserInfo;
  onSubmitUserInfo: (name: string) => void;
  userInfoResult: boolean;
  error: ApiError | null;
  isLoading: boolean;
}> = ({ userInfo, onSubmitUserInfo, userInfoResult, error, isLoading }) => {
  const [userName, setUserName] = useState(userInfo?.name ?? "");

  useEffect(() => {
    setUserName(userInfo?.name ?? "");
  }, [userInfo]);

  return (
    <Accordion defaultExpanded disableGutters>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='panel1a-content'
        id='panel1a-header'
      >
        <Typography
          variant='h6'
          sx={{
            fontWeight: "800",
            fontSize: "20px",
            lineHeight: "28px",
            letterSpacing: "0.5px",
            color: "#1C1F21",
          }}
        >
          Personal information
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form autoComplete='off'>
          <Stack direction={"column"} spacing={2}>
            <TextField
              aria-autocomplete='none'
              value={userName}
              name='name'
              label='Name'
              onChange={(e) =>
                setUserName((e.target as HTMLTextAreaElement).value)
              }
            />
            <TextField
              value={userInfo?.email ?? ""}
              name='email'
              label='E-mail'
              inputProps={{
                disabled: true,
              }}
            />
            <TextField
              value={userInfo?.phone ?? ""}
              name='phone'
              label='Phone Number'
              inputProps={{
                disabled: true,
              }}
            />
          </Stack>
        </form>
        {userInfoResult && (
          <Alert sx={{ marginTop: "12px" }} severity='success'>
            Your personal information is successfully updated
          </Alert>
        )}
        {error && (
          <Alert sx={{ marginTop: "12px" }} severity='error'>
            {error.message}
          </Alert>
        )}
        <Button
          onClick={() => onSubmitUserInfo(userName)}
          variant='contained'
          size='large'
          sx={{ marginTop: "16px" }}
          disabled={userInfo?.name === userName || isLoading}
        >
          Save changes
        </Button>
      </AccordionDetails>
    </Accordion>
  );
};
